module.exports = __webpack_public_path__ + "357e5c242b7cb3f7b6ca6fcc9cbde44c.png";